import { TemplatePage } from './types';

const liveStreamCoffeeTheme: TemplatePage = {
  header: {
    color: '#E3D0C1',
    icon: 'images/video-templates/coffee_theme.jpg',
    title: 'Live Stream Templates — Coffee Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Coffee Theme',
    description_meta:
      'Use Wave.video’s coffee-themed templates to make your live streams look elegant & professional. ' +
      'The set contains free transition screens, overlays, and frames.',
    description:
      'Make your live streams stand out with our coffee-themed templates. Create elegant visual components ' +
      'even with no design skills. You will get a set of pre-designed overlays, transition screens, and frames ' +
      'that perfectly fit multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>`
  },
  footer: {
    category: 'Live streaming coffee theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates, you will ' +
      'wow your viewers and boost your fanbase! All you need to do is open a template that fits your style and ' +
      'replace a few elements. Create eye-catching thumbnails, countdown, intro, lower thirds, technical issue ' +
      'screen with no design background. Becoming a professional live streamer has never been so easy.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming coffee theme',
      search: { name: 'CoffeeTheme', tags: 'CoffeeTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamCoffeeTheme;
